import { useState, useContext } from 'react'
import { t } from 'ttag'

import { UserSettingsIcon } from '@h2/components/icons/userSettings'
import { ImportIcon } from '@h2/components/icons/import'
import { RunAReportIcon } from '@h2/components/icons/runAReport'
import { EnvelopeIcon } from '@h2/components/icons/envelope'
import { SLB } from '@h2/components/colors'
import { GroupsIcon } from '@h2/components/icons/groups'
import { Globals } from '@h2/globals'

import { FullWidth } from './common/overview/fullWidth'
import { Overview } from './common/overview'

import { OverviewItem } from '../components/common/overview/overviewItem'
import { addCommas } from '../utils'

const UsersOverview = ({ dashboard, isFetching, isSubscriber }) => {
  const [allUsers, setAllUsers] = useState(false)
  const baseUserStats = allUsers ? dashboard?.siteUsers : dashboard?.users
  const logins = baseUserStats?.logins
  const activities = baseUserStats?.activities
  const users = baseUserStats?.users
  const groups = baseUserStats?.groups
  const chartProps = {
    dot: { r: 1 },
    strokeWidth: 1
  }
  const { isNavianceElementary } = useContext(Globals)

  return (
    <Overview
      fullWidth={true}
      icon={GroupsIcon}
      title={allUsers ? t`All Site Users` : t`Your Users`}
      dropdown={{
        text: t`Actions`,
        items: [
          {
            icon: ImportIcon,
            text: t`Import Users`,
            href: '/management/users/importer',
            subscriberOnly: true
          },
          {
            icon: GroupsIcon,
            text: t`Manage Groups`,
            href: '/management/groups',
            subscriberOnly: false
          },
          {
            icon: UserSettingsIcon,
            text: t`Manage Users`,
            href: '/management/users',
            subscriberOnly: false
          },
          {
            icon: RunAReportIcon,
            text: t`Run Reports`,
            href: '/management/users',
            subscriberOnly: false
          },
          {
            icon: EnvelopeIcon,
            text: t`Send A Message`,
            href: '/management/users',
            subscriberOnly: false,
            disabled: isNavianceElementary
          }
        ]
      }}
      inviteUsers={false}
      importUsers={true}>
      <FullWidth
        allUsers={allUsers}
        setAllUsers={setAllUsers}
        canToggle={dashboard?.siteUsers}>
        <OverviewItem isFetching={isFetching}>
          <OverviewItem.Heading color={SLB}>
            {addCommas(logins?.total)}
          </OverviewItem.Heading>
          <OverviewItem.Text>{t`Logins`}</OverviewItem.Text>
          <OverviewItem.Chart data={logins?.dataPoints} {...chartProps} />
        </OverviewItem>

        <OverviewItem isFetching={isFetching}>
          <OverviewItem.Heading color={SLB}>
            {addCommas(activities?.total)}
          </OverviewItem.Heading>
          <OverviewItem.Text>{t`Activities completed`}</OverviewItem.Text>
          <OverviewItem.Chart data={activities?.dataPoints} {...chartProps} />
        </OverviewItem>

        <OverviewItem isFetching={isFetching}>
          <OverviewItem.Heading color={SLB}>
            {addCommas(users?.total)}
          </OverviewItem.Heading>
          <OverviewItem.Text>{t`Users`}</OverviewItem.Text>
        </OverviewItem>

        {isSubscriber && (
          <OverviewItem isFetching={isFetching} locked={!isSubscriber}>
            <OverviewItem.Heading color={SLB}>
              {addCommas(groups?.total)}
            </OverviewItem.Heading>
            <OverviewItem.Text>{t`Number of Groups`}</OverviewItem.Text>
          </OverviewItem>
        )}
      </FullWidth>
    </Overview>
  )
}

export { UsersOverview }
